import { selectSelectedPortfolioId } from '@unistocks/features/portfolios/store/portfolio.slice';
import { usePortfoliosGetListQuery } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { Href } from 'expo-router';

export const useDefaultPortfollioRoute = (): Href => {
  const { data: portfolios } = usePortfoliosGetListQuery();
  const selectedPortfolioId =
    useAppSelector(selectSelectedPortfolioId) ?? portfolios?.items[0]?.id ?? '';

  const portfolioHref: Href = selectedPortfolioId
    ? {
        pathname: '/(tabs)/portfolios/[id]',
        params: { id: selectedPortfolioId }
      }
    : '/(tabs)/portfolios/create';

  return portfolioHref;
};
